import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-sahbak-tips',
  templateUrl: './sahbak-tips.component.html',
  styleUrls: ['./sahbak-tips.component.css']
})
export class SahbakTipsComponent implements OnInit {
  @Input() step: number;
  tipsList = [
    'סחבק מאפשר לכם לשאול שאלות סינון שיעבירו רק מועמדים רלוונטים.',
    'עד עכשיו סחבק העביר ללקוחות יותר 500,000 לידים.',
    '',
    'בסחבק יש עמוד עבודה מועדפת עם משרות שוות במיוחד',
    'הידעת בכל יום בסחבק מתפרסמות כ125 משרות חדשות',

  ];

  tip: string;
  constructor() { }

  ngOnInit() {
    this.tip = this.tipsList[this.step - 1 ];
  }

}
